import React from 'react';
import PropTypes from 'prop-types';
import { compose, pure } from 'recompose';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { StyledHeader, SubtitleHeader } from '../../style';
import Multimedia from '../../../Multimedia';

const stylesForVideo = {
  marginBottom: '6rem'
};

const HeaderNews = ({
  className,
  title,
  subtitle,
  mediaType,
  src,
  onToggleFullSize,
  author
}) => (
  <StyledHeader
    className={className}
    style={mediaType === 'VIDEO' ? stylesForVideo : null}
  >
    <Helmet>
      <title>{title || 'A3Mil Intranet'}</title> {/* Cambia el título aquí */}
    </Helmet>
    <h1>{title}</h1>
    <SubtitleHeader>{subtitle}</SubtitleHeader>
    {mediaType && (
      <Multimedia
        title={title}
        subtitle={subtitle}
        author={author}
        media={mediaType}
        src={src}
        onToggleFullSize={onToggleFullSize}
      />
    )}
  </StyledHeader>
);
HeaderNews.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  mediaType: PropTypes.string
};
export default compose(pure)(HeaderNews);
